import { render, staticRenderFns } from "./submit-body.vue?vue&type=template&id=4abd7e87&"
import script from "./submit-body.vue?vue&type=script&lang=ts&"
export * from "./submit-body.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports